/* models/tooltip_icon.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    var _a;
    const control_1 = require("@bokehjs/models/widgets/control");
    const tooltip_1 = require("@bokehjs/models/ui/tooltip");
    const build_views_1 = require("@bokehjs/core/build_views");
    const dom_1 = require("@bokehjs/core/dom");
    const inputs_css_1 = tslib_1.__importStar(require("@bokehjs/styles/widgets/inputs.css")), inputs = inputs_css_1;
    const icons_css_1 = tslib_1.__importDefault(require("@bokehjs/styles/icons.css"));
    class TooltipIconView extends control_1.ControlView {
        *controls() { }
        *children() {
            yield* super.children();
            yield this.description;
        }
        async lazy_initialize() {
            await super.lazy_initialize();
            const { description } = this.model;
            this.description = await (0, build_views_1.build_view)(description, { parent: this });
        }
        remove() {
            var _b;
            (_b = this.description) === null || _b === void 0 ? void 0 : _b.remove();
            super.remove();
        }
        stylesheets() {
            return [...super.stylesheets(), inputs_css_1.default, icons_css_1.default];
        }
        render() {
            super.render();
            const icon_el = (0, dom_1.div)({ class: inputs.icon });
            this.desc_el = (0, dom_1.div)({ class: inputs.description }, icon_el);
            const { desc_el, description } = this;
            description.model.target = desc_el;
            let persistent = false;
            const toggle = (visible) => {
                description.model.setv({
                    visible,
                    closable: persistent,
                });
                icon_el.classList.toggle(inputs.opaque, visible && persistent);
            };
            this.on_change(description.model.properties.visible, () => {
                const { visible } = description.model;
                if (!visible) {
                    persistent = false;
                }
                toggle(visible);
            });
            desc_el.addEventListener('mouseenter', () => {
                toggle(true);
            });
            desc_el.addEventListener('mouseleave', () => {
                if (!persistent)
                    toggle(false);
            });
            document.addEventListener('mousedown', (event) => {
                const path = event.composedPath();
                if (path.includes(description.el)) {
                    return;
                }
                else if (path.includes(desc_el)) {
                    persistent = !persistent;
                    toggle(persistent);
                }
                else {
                    persistent = false;
                    toggle(false);
                }
            });
            window.addEventListener('blur', () => {
                persistent = false;
                toggle(false);
            });
            // Label to get highlight when icon is hovered
            this.shadow_el.appendChild((0, dom_1.label)(this.desc_el));
        }
        change_input() { }
    }
    exports.TooltipIconView = TooltipIconView;
    TooltipIconView.__name__ = "TooltipIconView";
    class TooltipIcon extends control_1.Control {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.TooltipIcon = TooltipIcon;
    _a = TooltipIcon;
    TooltipIcon.__name__ = "TooltipIcon";
    TooltipIcon.__module__ = 'panel.models.widgets';
    (() => {
        _a.prototype.default_view = TooltipIconView;
        _a.define(({ Ref }) => ({
            description: [Ref(tooltip_1.Tooltip), new tooltip_1.Tooltip()],
        }));
    })();
}
